import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
	} satisfies Record<string, CSSObject>)
}
